export enum InvoiceStatus {
    NEW = 'new',
    EXPIRED = 'expired',
    CANCELED = 'canceled',
    PAID = 'paid',
    //PAID_PART = 'paid_part',
}